import React from 'react';
import { Number } from '../../common';

export const TableNumber = (props) => {
  return <Number compact={false} dashForNone {...props} />;
};
